import React from 'react';
import Hero from './components/Hero';
import ProblemSolution from './components/ProblemSolution';
import HowItWorks from './components/HowItWorks';
import Features from './components/Features';
import Pricing from './components/Pricing';
import Testimonials from './components/Testimonials';
import FAQ from './components/FAQ';
import ContactForm from './components/ContactForm';
import Footer from './components/Footer';
import '@/App.css';

function App() {
  return (
    <div className="App">
      <Hero />
      <ProblemSolution />
      <HowItWorks />
      <div id="features">
        <Features />
      </div>
      <div id="pricing">
        <Pricing />
      </div>
      <Testimonials />
      <div id="faq">
        <FAQ />
      </div>
      <ContactForm />
      <Footer />
    </div>
  );
}

export default App;